import Icon from 'veui/components/Icon'

Icon.register({
  'file-img': {
    paths: [
      {
        fill: '#59acff',
        d: 'M27.68 9.81l-6.66-8a1.34 1.34 0 00-1.03-.48H6a2 2 0 00-2 2v25.34c0 1.1.9 2 2 2h20a2 2 0 002-2v-18c0-.05-.06-.56-.3-.86z'
      },
      {
        fill: '#9cd7ff',
        d: 'M21.02 1.81a1.34 1.34 0 00-1.03-.48v7.34c0 1.1.9 2 2 2h6c0-.05-.06-.56-.3-.86z'
      },
      {
        fill: '#fff',
        d: 'M18.26 14.86l-3.7 4.45-1.65-2a.57.57 0 00-.94.09l-3.88 6.67c-.24.42.04.95.5.95h15.3c.46 0 .75-.53.51-.95l-5.2-9.12a.57.57 0 00-.94-.1zM15 22.04l3.47-4.2 2.86 5.03H11.17l1.5-2.58 1.45 1.75a.57.57 0 00.89 0zm-1.48-8.55c0 .87-.66 1.57-1.49 1.57s-1.49-.7-1.49-1.57c0-.87.67-1.58 1.5-1.58s1.48.7 1.48 1.58z'
      }
    ],
    width: '32',
    height: '32'
  }
})
